import { Routes, Route } from 'react-router-dom';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Signup from './pages/Signup';
import VerifyEmail from './pages/VerifyEmail';
import Dashboard from './pages/Dashboard';
import ImageStudio from './pages/ImageStudio';
import MusicStudio from './pages/MusicStudio';
import CodeStudio from './pages/CodeStudio';
import Chat from './pages/Chat';
import History from './pages/History';
import Profile from './pages/Profile';
import Pricing from './pages/Pricing';
import NotFound from './pages/NotFound';
import AppLayout from './components/layout/AppLayout';
import ProtectedRoute, { PublicOnlyRoute } from './components/layout/ProtectedRoute';

export default function App() {
  return (
    <Routes>
      {/* Public marketing */}
      <Route path="/" element={<Landing />} />

      {/* Auth (redirect away if already signed in) */}
      <Route element={<PublicOnlyRoute />}>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
      </Route>

      {/* Authenticated app */}
      <Route element={<ProtectedRoute />}>
        <Route path="/app" element={<AppLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="image" element={<ImageStudio />} />
          <Route path="music" element={<MusicStudio />} />
          <Route path="code" element={<CodeStudio />} />
          <Route path="chat" element={<Chat />} />
          <Route path="history" element={<History />} />
          <Route path="profile" element={<Profile />} />
          <Route path="pricing" element={<Pricing />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
